/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取绑定的微信第三方账户,如果不存在则绑定除memberId外的第三方信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  wxUserReq: member.WxUserReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.WxUserDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/binding/info`,
    data: wxUserReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
